/**
 * Mock crew data for CustomLandingPage
 * Uses an inline placeholder image so production build does not 404 and CSP stays tight.
 */

const PLACEHOLDER_IMAGE =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200' viewBox='0 0 300 200'%3E%3Crect width='300' height='200' fill='%231a1a2e'/%3E%3Ctext x='150' y='106' text-anchor='middle' font-family='Arial, sans-serif' font-size='28' font-weight='700' fill='%23eeeeee'%3ECrew%3C/text%3E%3C/svg%3E";

export const mockCrews = [
  {
    id: 'taylor-swift',
    name: 'Taylor Swift',
    artist: 'Taylor Swift',
    status: 'Active Crew',
    fans: '15.2K',
    memberCount: '15.2K',
    postCount: '42',
    linkUps: '23',
    ticketBids: '156',
    ticketListings: '89',
    category: 'Music',
    location: 'Nashville, TN',
    hasLinkUps: true,
    description:
      "Join fellow Swifties to discuss the latest albums, tour dates and share your favorite Taylor Swift moments. From folklore to Midnights, we celebrate all eras of Taylor's incredible journey.",
    image: PLACEHOLDER_IMAGE,
  },
  {
    id: 'beyonce',
    name: 'Beyoncé',
    artist: 'Beyoncé',
    status: 'Active Crew',
    fans: '12.8K',
    memberCount: '12.8K',
    postCount: '38',
    linkUps: '18',
    ticketBids: '124',
    ticketListings: '67',
    category: 'Music',
    location: 'Houston, TX',
    hasLinkUps: true,
    description:
      "The Beyhive assembles here! Celebrate Queen B's artistry, from Destiny's Child classics to Renaissance. Share concert experiences, discuss lyrics and stay updated on all things Beyoncé.",
    image: PLACEHOLDER_IMAGE,
  },
  {
    id: 'lakers',
    name: 'Lakers Nation',
    artist: 'Los Angeles Lakers',
    status: 'Active Crew',
    fans: '18.5K',
    memberCount: '18.5K',
    postCount: '52',
    linkUps: '28',
    ticketBids: '189',
    ticketListings: '95',
    category: 'Sports',
    location: 'Los Angeles, CA',
    hasLinkUps: true,
    description:
      'Lakers faithful unite! Discuss games, players, and share the purple and gold pride. From Showtime to the present, we celebrate Lakers basketball and connect with fellow fans.',
    image: PLACEHOLDER_IMAGE,
  },
  {
    id: 'broadway-fans',
    name: 'Broadway Fans',
    artist: 'Broadway',
    status: 'Active Crew',
    fans: '11.3K',
    memberCount: '11.3K',
    postCount: '35',
    linkUps: '22',
    ticketBids: '98',
    ticketListings: '54',
    category: 'Theater',
    location: 'New York, NY',
    hasLinkUps: true,
    description:
      'Broadway lovers assemble! Share reviews, discuss shows, and connect with fellow theater enthusiasts. From Hamilton to Wicked, we celebrate the magic of live theater.',
    image: PLACEHOLDER_IMAGE,
  },
  {
    id: 'drake',
    name: 'Drake Fans',
    artist: 'Drake',
    status: 'Active Crew',
    fans: '10.1K',
    memberCount: '10.1K',
    postCount: '24',
    linkUps: '12',
    ticketBids: '134',
    ticketListings: '78',
    category: 'Music',
    location: 'Toronto, ON',
    hasLinkUps: false,
    description:
      "The 6 God's official Crew. From Toronto to the world, discuss Drake's latest drops, OVO updates and share your favorite bars from Drizzy's extensive catalog.",
    image: PLACEHOLDER_IMAGE,
  },
  {
    id: 'festival-squad',
    name: 'Festival Squad',
    artist: 'Music Festivals',
    status: 'Active Crew',
    fans: '22.7K',
    memberCount: '22.7K',
    postCount: '48',
    linkUps: '35',
    ticketBids: '156',
    ticketListings: '89',
    category: 'Music',
    location: 'Various',
    hasLinkUps: true,
    description:
      "Festival fanatics unite! From Coachella to EDC, discuss lineups, share tips, and connect with fellow festival-goers. Let's make unforgettable memories together.",
    image: PLACEHOLDER_IMAGE,
  },
  {
    id: 'celtics-pride',
    name: 'Celtics Pride',
    artist: 'Boston Celtics',
    status: 'Active Crew',
    fans: '14.2K',
    memberCount: '14.2K',
    postCount: '41',
    linkUps: '19',
    ticketBids: '112',
    ticketListings: '61',
    category: 'Sports',
    location: 'Boston, MA',
    hasLinkUps: true,
    description:
      'Celtics faithful unite! Celebrate the green and white, discuss games, players, and the rich history of Boston basketball. Banner 18 and beyond!',
    image: PLACEHOLDER_IMAGE,
  },
  {
    id: 'musical-lovers',
    name: 'Musical Lovers',
    artist: 'Musical Theater',
    status: 'Active Crew',
    fans: '9.8K',
    memberCount: '9.8K',
    postCount: '29',
    linkUps: '16',
    ticketBids: '87',
    ticketListings: '43',
    category: 'Theater',
    location: 'New York, NY',
    hasLinkUps: true,
    description:
      'Musical theater enthusiasts unite! From classic shows to new productions, share your love for song and dance. Connect with fellow fans who live for the spotlight.',
    image: PLACEHOLDER_IMAGE,
  },
];
